import { ActivityIndicator, Platform, StyleSheet, View } from 'react-native';

import { Text } from '../Text';
import { colors } from '../../theme';
import { SplashScreen } from '../SplashScreen';

interface Props {
	show: boolean;
	text?: string;
	variant?: 'spinner' | 'splashScreen';
}

export const LoadingOverlay = ({ show, text, variant = 'spinner' }: Props) => {
	if (!show) {
		return null;
	}

	return (
		<View style={styles.root}>
			{variant === 'spinner' ? (
				<ActivityIndicator size="large" color={colors.white} />
			) : (
				<SplashScreen />
			)}
			<Text style={styles.text}>{text}</Text>
		</View>
	);
};

const styles = StyleSheet.create({
	root: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
		width: '100%',
		//@ts-expect-error valid web value
		position: Platform.OS === 'web' ? 'fixed' : 'absolute',
		zIndex: 1,
		top: 0,
		left: 0,
		backgroundColor: colors.primarySemiTransparent,
	},
	text: {
		color: colors.white,
		fontSize: 20,
		fontFamily: 'Poppins-Medium',
		marginTop: 16,
	},
});
